import { Component } from '@angular/core';

@Component({
  selector: 'app-details-skeleton',
  standalone: true,
  templateUrl: './details-skeleton.component.html',
  styleUrl: './details-skeleton.component.scss'
})
export class DetailsSkeletonComponent {
  readonly skeletonCols = new Array(2);
  readonly skeletonRows = new Array(8);
}
